import React, { useEffect } from 'react';
import BlueprintLogo from './BlueprintLogo';

/*
 * Startup screen for Yodeck signage players, which cannot afford the animated
 * loader. Same blueprint backdrop and flag mark, but painted once: no canvas,
 * no requestAnimationFrame, no transitions or keyframes (.sl-root--static).
 *
 * The centre card echoes the title block on the 2D blueprint drawing. It goes
 * away the moment startup data is in - no close-up, no fade.
 */

interface Props {
  statusText: string;
  ready: boolean;
  error?: boolean;
  onRetry?: () => void;
  onDone?: () => void;
}

const SignageLoader = ({ statusText, ready, error, onRetry, onDone }: Props) => {
  useEffect(() => {
    if (ready) onDone?.();
  }, [ready, onDone]);

  return (
    <div className="sl-root sl-root--static" data-error={error || undefined}>
      <BlueprintLogo />
      <div className="sl-sign">
        <div className="sl-sign-row sl-brand" aria-hidden="true">MAINTENER</div>
        <div className="sl-sign-row sl-sign-status">
          <div className="sl-caption" role="status" aria-live="polite">{statusText}</div>
          <div className="sl-sign-rule" aria-hidden="true" />
          {error && onRetry && (
            <button type="button" className="sl-retry" onClick={onRetry}>Retry</button>
          )}
        </div>
        <div className="sl-sign-row sl-sign-note" aria-hidden="true">Display mode · starting up</div>
      </div>
    </div>
  );
};

export default SignageLoader;
